import React from 'react';
import ReactDOM from 'react-dom/client';
import { MsalProvider } from '@azure/msal-react';
import './index.css';
import App from './App';
import { msalInstance } from './auth/msalConfig';
import { getIdToken, makeAuthFetch, restoreReturnRoute } from './auth/session';
import SessionExpiredBar from './components/layout/SessionExpiredBar';
import { CLIENT_ID } from './live/clientId';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Attach the signed-in user's Entra ID token to every same-origin API call so
// the server can verify who is asking (server/middleware/auth.js). One
// interceptor instead of touching ~40 fetch call sites; requests made while
// signed out simply go through without the header. When an account is cached
// but no token can be minted, src/auth/session.js raises the session-expired
// event and SessionExpiredBar offers a user-initiated Continue.
window.fetch = makeAuthFetch(window.fetch.bind(window), CLIENT_ID);

// MSAL v5 requires initialize() before any auth calls. With the redirect flow,
// handleRedirectPromise() must run on load to finish the sign-in when we return
// from Microsoft (it reads the #code response, exchanges it for tokens, and
// clears the URL) BEFORE the app renders. Render as soon as that resolves — do
// NOT block first paint on a token fetch (that was the slow blank screen); the
// fetch interceptor acquires tokens per-request; an expired session shows the bar.
msalInstance
  .initialize()
  .then(() => msalInstance.handleRedirectPromise())
  .catch((e) => {
    console.error('MSAL redirect handling failed:', e);
  })
  .finally(() => {
    // Back from the session bar's Continue → the page the user was on.
    restoreReturnRoute();
    root.render(
      <MsalProvider instance={msalInstance}>
        <SessionExpiredBar />
        <App />
      </MsalProvider>
    );
    // Warm the token cache in the background so the opening data burst carries a
    // header on its first try (non-blocking — render already happened).
    getIdToken();
  });
